import { configureStore } from '@reduxjs/toolkit';
import authReducer from './authSlice';
import appointmentReducer from './appointmentSlice';
import contactReducer from './contactSlice';
import acceptAppointmentReducer from './acceptAppointmentSlice';
import deleteAppointmentReducer from './deleteAppointmentSlice';
import deleteMessageReducer from './deleteMessageSlice';
import testimonialReducer from './testimonialSlice';
import getTestimonialReducer from './getTestimonialSlice';
import testimonialUpdateReducer from './testimonialUpdateSlice';
import testimonialDeleteReducer from "./testimonialDeleteSlice";


export const store = configureStore({
  reducer: {
    auth: authReducer,
    appointments : appointmentReducer,
    contacts : contactReducer,
    appointment : acceptAppointmentReducer,
    appointmentDelete : deleteAppointmentReducer,
    messageDelete: deleteMessageReducer,
    testimonials : testimonialReducer,
    alltestimonials : getTestimonialReducer,
    testimonialUpdate : testimonialUpdateReducer,
    testimonialDelete : testimonialDeleteReducer,
  },
});
